/**
 * @imports
 */
import React, { useState } from 'react'
import { Button, Modal, Table, Tag, Tooltip } from 'antd'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { Cell } from '../../../components'
import moment from 'moment'
import { PeriodoInicioTermino } from './periodo-inicio-termino'

/**
 *
 * @param {*} props
 * @returns
 */
export function ComPeriodosSuministroEquipo(props) {
  if (!props.info) { return null }

  const columns = Cell.buildList([
    { title: 'Periodo', dataIndex: 'periodo', width: '350px', render: (val, row) => (
      <PeriodoRentaListItem
        periodo={row}
        onEditarSolicitudPago={props.onEditarSolicitudPago}
      />
    )},
  ])

  return (
    <Modal
      visible={props.visible}
      onCancel={props.onClose}
      width={'70%'}
      >
      <Table
        rowKey='iId'
        size='small'
        rowClassName='row-pure'
        dataSource={props.info.periodosRenta}
        columns={columns}
        loading={props.loading}
        pagination={false}
        // title={() => tableTitle}
      />
    </Modal>
  )
}

/**
 *
 * @param {*} props
 * @returns
 */
export function PeriodoRentaListItem(props) {
  const { periodo: info } = props
  const [loading, setLoading] = useState(props.loading)

  const handleIngresar = () => {
    setLoading(true)

    const payload = {
      identificador: 'maq@crearOrdenPagoMaqBitacoraPeriodo',
      params: [info.iId, moment().format('YYYY-MM-DD')],
    }

    Api.post('/kernel/jobs/do', payload)
      .then((res) => {
        setLoading(false)
        props.onEditarSolicitudPago && props.onEditarSolicitudPago(res.data)
      })
      .catch((err) => {
        setLoading(false)
        Exception.load(err).show()
      })
  }

  const ref = !info.factura ? undefined : info.factura.referencia
  const inicio = moment(info.inicio).format('MMM DD YY')
  const fin = moment(info.fin).format('MMM DD YY')
  const tieneRechazos = info.factura && info.factura.adjuntos.filter(a => a.iAceptado != null).length > 0
  const adicional_pend = Boolean(info.adicional) && info.status_ad === 'PENDIENTE'

  return (
    <div style={{ marginBottom: 5, marginTop: 5, display: 'flex', alignItems: 'center' }}>
      <div>
        <PeriodoInicioTermino
          inicio={inicio}
          fin={fin}
        />

        {info.factura ? null :
          (adicional_pend ?
            <Tag color='orange'>ADICIONAL SIN VALIDACIÓN</Tag> :

            <Button
              loading={loading}
              icon='container'
              type='default'
              size='small'
              children='Ingresar'
              onClick={handleIngresar}
              style={{ marginLeft: 10, marginRight: 10 }}
            />
          )}
      </div>

      {!info.factura ? null : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Tag color='purple'>{ref}</Tag>

          <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
            <Tooltip title='Detalles de factura'>
              <Button
                loading={loading}
                icon='edit'
                type='default'
                size='small'
                onClick={() => props.onEditarSolicitudPago && props.onEditarSolicitudPago(info.factura)}
              />
            </Tooltip>
          </div>

          {/* <Tag>{importe + ' ' + moneda}</Tag> */}
          <Tag color={info.factura.status === 'PAGADO' ? 'green' : (tieneRechazos ? 'red' : undefined)}>{info.factura.status}</Tag>
          {!tieneRechazos ? null : (
            <Tag color='red'><b>ADJUNTOS CON RECHAZO</b></Tag>
          )}
        </div>
      )}
    </div>
  )
}
